import type { ReactNode } from 'react';

/**
 * Вкладки объекта `.secbar` (кит v2.11). Без счётчиков. Ряд из одной
 * вкладки не рисуется — у карточки тогда просто «Обзор» (ТЗ M2 7.3).
 */
export function ObjectTabs<T extends string>({
  items,
  value,
  onChange,
}: {
  items: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}) {
  if (items.length < 2) return null;
  return (
    <div className="secbar">
      <div className="tabs">
        {items.map((t) => (
          <div key={t.value} className={t.value === value ? 'tab on' : 'tab'} onClick={() => onChange(t.value)}>
            {t.label}
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * Полоса раздела `.segbar`: подразделы (без счётчиков — внутри карточки
 * их нет) и кнопка раздела справа. Кнопка раздела — тихая: графитовая
 * на экране одна, и это действие объекта (кит 2.12).
 */
export function SectionHeader<T extends string>({
  segments,
  actions,
}: {
  segments?: { items: { value: T; label: string }[]; value: T; onChange: (value: T) => void };
  actions?: ReactNode;
}) {
  const showSegs = segments && segments.items.length > 1;
  return (
    <div className={showSegs ? 'segbar' : 'segbar noseg'}>
      {showSegs ? (
        <div className="segs">
          {segments.items.map((s) => (
            <span
              key={s.value}
              className={s.value === segments.value ? 'seg on' : 'seg'}
              onClick={() => segments.onChange(s.value)}
            >
              {s.label}
            </span>
          ))}
        </div>
      ) : null}
      <div className="sp" />
      {actions}
    </div>
  );
}
